<div class="login-page" *ngIf="!hideRest">

  <div class="login-left">

    <div class="left-login">

      <div class="text-primary">
        <h5 class="welcome-title">Switch Role</h5>
        <p class="welcome-subtitle">
          Please confirm your details to continue.
        </p>
      </div>

      <form [formGroup]="registerForm" (ngSubmit)="submitSwitchRole()">

        <div class="form-group">
          <label>Register As</label>
          <input type="text" class="form-control"
                 [value]="pendingType == '1' ? 'Buyer' : 'Seller'" disabled>
        </div>

        <div class="form-group">
          <label>First Name</label>
          <input type="text" class="form-control" formControlName="first_name">
        </div>

        <div class="form-group">
          <label>Last Name</label>
          <input type="text" class="form-control" formControlName="last_name">
        </div>

        <div class="form-group">
          <label>Email</label>
          <input type="email" class="form-control" formControlName="email">
        </div>

        <div class="form-group">
          <label>Country</label>
          <input type="text" class="form-control" formControlName="country">
        </div>

        <div class="form-group">
          <label>Mobile Number</label>
          <input type="text" class="form-control" formControlName="phone">
        </div>

        <div class="form-check mt-3">
          <input type="checkbox" formControlName="acceptTerms" class="form-check-input">
          <label class="form-check-label">
            I agree to the Terms & Conditions
          </label>
        </div>

        <div class="mt-4">
          <button class="btn btn-primary w-100" type="submit">
            Register
          </button>
        </div>

      </form>

    </div>

  </div>

  <div class="login-right">
    <div class="poster-overlay"></div>
    <p class="right-text">Lead your content to global success with us.</p>
  </div>

</div>

<div class="container text-center" *ngIf="hideRest">
  <img src="assets/images/load.gif" width="80">
</div>
